export const DEFAULT_LANGUAGE = 'ko';

export const LANGUAGE_STORAGE_KEY =
  'hanwhaSemitechSoftwarePlatformLanguage';

export const SUPPORTED_LANGUAGES = Object.freeze([
  {
    code: 'ko',
    htmlLang: 'ko-KR',
    labelKey: 'languages.ko',
  },
  {
    code: 'en',
    htmlLang: 'en-US',
    labelKey: 'languages.en',
  },
  {
    code: 'tr',
    htmlLang: 'tr-TR',
    labelKey: 'languages.tr',
  },
  {
    code: 'pt',
    htmlLang: 'pt-BR',
    labelKey: 'languages.pt',
  },
  {
    code: 'hi',
    htmlLang: 'hi-IN',
    labelKey: 'languages.hi',
  },
  {
    code: 'es',
    htmlLang: 'es-ES',
    labelKey: 'languages.es',
  },
  {
    code: 'de',
    htmlLang: 'de-DE',
    labelKey: 'languages.de',
  },
  {
    code: 'zh',
    htmlLang: 'zh-CN',
    labelKey: 'languages.zh',
  },
  {
    code: 'it',
    htmlLang: 'it-IT',
    labelKey: 'languages.it',
  },
  {
    code: 'pl',
    htmlLang: 'pl-PL',
    labelKey: 'languages.pl',
  },
  {
    code: 'cs',
    htmlLang: 'cs-CZ',
    labelKey: 'languages.cs',
  },
  {
    code: 'uk',
    htmlLang: 'uk-UA',
    labelKey: 'languages.uk',
  },
  {
    code: 'uz',
    htmlLang: 'uz-UZ',
    labelKey: 'languages.uz',
  }
]);

export const SUPPORTED_LANGUAGE_CODES = Object.freeze(
  SUPPORTED_LANGUAGES.map((language) => language.code),
);

export function getLanguageConfig(languageCode) {
  const normalizedCode = String(languageCode || '')
    .trim()
    .toLowerCase()
    .replace('_', '-');

  const exactMatch = SUPPORTED_LANGUAGES.find(
    (language) => language.code.toLowerCase() === normalizedCode,
  );

  if (exactMatch) {
    return exactMatch;
  }

  const baseLanguageCode = normalizedCode.split('-')[0];

  return (
    SUPPORTED_LANGUAGES.find(
      (language) => language.code === baseLanguageCode,
    ) ||
    SUPPORTED_LANGUAGES.find(
      (language) => language.code === DEFAULT_LANGUAGE,
    )
  );
}